import { render } from "./retainPopup.vue?vue&type=template&id=0f0f7710&scoped=true"
import script from "./retainPopup.vue?vue&type=script&lang=js"
export * from "./retainPopup.vue?vue&type=script&lang=js"

import "./retainPopup.vue?vue&type=style&index=0&id=0f0f7710&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0f7710"]])

export default __exports__